import { Typography } from '@material-ui/core';
import styled from 'styled-components'
import ListItem from '@material-ui/core/ListItem';
import { blue, grey, hoverBlue } from '../../assets/ui/colors';

export const LkTitle = styled(Typography)`
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
`;

export const CustomListItem = styled(ListItem)`
    font-weight: 600;
    border-radius: 4px;
    color: ${props => props.isactive ? blue : grey};
    background: ${props => props.isactive ? hoverBlue : 'white'};
    font-weight: bold;
    :hover {
        background: ${props => props.isactive ? hoverBlue : 'white'};
    }
    & svg {
        fill: ${props => props.isactive ? blue : grey};
    }
`;

export const RegOfficeContacts = styled.div`
    margin: auto 8px 8px 8px;
    padding: 16px;
    color: ${grey};
    & a {
        color: ${blue};
    }
`;
